module.exports = __webpack_public_path__ + "static/media/solar-panels.bf9ded5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/solar-panels.jpg
// module id = 1832
// module chunks = 0